import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import PropTypes from 'prop-types'

import sceneLogic from '~/scenes/search/logic'
import filtersLogic from '~/scenes/search/filters-page/logic'

import LocationFilters from './pages/location-filters'
import PriceFilters from './pages/price-filters'
import LanguageFilters from './pages/language-filters'
import AgesFilters from './pages/ages-filters'
import TopActions from './pages/top-actions'
import BottomActions from './pages/bottom-actions'
import AllFilters from './pages/all-filters'
import CategoryTagsFilters from './pages/category-tags-filters'

export default function Filters ({ fullScreenFiltersPage }) {
  const { isSmallScreen } = useValues(sceneLogic)
  const { activeSubMenu } = useValues(filtersLogic)

  return (
    <div
      className={`all-filters auto-scroll ${
        activeSubMenu === 'location' && fullScreenFiltersPage ? 'white-background' : ''
      }`}
    >
      {fullScreenFiltersPage && (
        <TopActions activeSubMenu={activeSubMenu} locationTopActionsStyles={activeSubMenu === 'location'} />
      )}

      {activeSubMenu === 'age' && <AgesFilters />}
      {activeSubMenu === 'location' && <LocationFilters fullScreenFiltersPage={fullScreenFiltersPage} />}
      {activeSubMenu === 'language' && !isSmallScreen && <LanguageFilters />}
      {activeSubMenu === 'price' && !isSmallScreen && <PriceFilters />}
      {(activeSubMenu === 'all' || (activeSubMenu === 'price' && isSmallScreen)) && <AllFilters />}
      {activeSubMenu === 'category_tags' && <CategoryTagsFilters fullScreenFiltersPage={fullScreenFiltersPage} />}

      {activeSubMenu !== 'location' && fullScreenFiltersPage && <BottomActions />}
    </div>
  )
}

Filters.propTypes = {
  fullScreenFiltersPage: PropTypes.bool
}
